export default __webpack_public_path__ + "static/media/elephant_mark.cba3cbbf.png";